<template>
  <div class="e-toggle">
    <ul>     
      <li
        v-for="option in data"
        :key="option.id"
        :class="selectedOption === option.id ? 'active' : ''">
        <label>
          <input
            v-model="selectedOption"
            type="radio"
            name="toggle"
            :value="option.id"
            @change="onChangeToggle" />
          {{ option.label }}
        </label>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      required: true,
      type: Array,
    },
  },
  emits: ['change-toggle'],
  data() {
    return {
      selectedOption: '',
    }
  },
  mounted() {
  

    if (this.data) {
      const selectedObject = this.data.find((item) => item.isSelected)
      this.selectedOption = selectedObject ? selectedObject.id : ''

          this.$nextTick(function () {
        this.onChangeToggle()
      })
    }
  },
  methods: {
    onChangeToggle() { 
      this.$emit('change-toggle', this.selectedOption)
    },
  },
}
</script>
